/* eslint-disable import/no-named-as-default */
import React from "react";
import { Provider } from "react-redux";
import store from "../../store";
import EmployerTimeToHireMetrics from "./EmployerTimeToHireMetrics";

const ProviderComponent = () => (
  <Provider store={store}>
    <EmployerTimeToHireMetrics />
  </Provider>
);

export default ProviderComponent;
